// extracted by mini-css-extract-plugin
export default {"profiles_container":"ProfilesBox_profiles_container__1FqTo"};